import { React, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import * as Airtable from "airtable";

export default function WaitlistForm() {
  const [message, setMessage] = useState("");

  const onFormSubmit = (submissionValue, { setSubmitting, resetForm }) => {
    setMessage("");
    const airtableBase = new Airtable({
      apiKey: process.env.REACT_APP_AIRTABLE_API_KEY,
    }).base(process.env.REACT_APP_AIRTABLE_BASE_ID);
    airtableBase(process.env.REACT_APP_AIRTABLE_TABLE_NAME).create(
      {
        email: submissionValue.email,
      },
      function (err, record) {
        if (err) {
          console.error(err);
          setMessage("Error: try again");
          return;
        }
      }
    );
    setSubmitting(false);
    setMessage("Success!");
  };

  return (
    <Formik
      initialValues={{ email: "" }}
      validationSchema={Yup.object({
        email: Yup.string().email("Invalid email address").required("Required"),
      })}
      onSubmit={onFormSubmit}>
      {(formik) => (
        <Form className="sm:max-w-xl sm:mx-auto lg:mx-0">
          <div className="sm:flex">
            <div className="min-w-0 flex-1">
              <label htmlFor="email" className="sr-only">
                Email Address
              </label>
              <Field
                name="email"
                type="email"
                placeholder="Email"
                className="block w-full px-4 py-3 rounded-md atext-base text-gray-900 placeholder-gray-500 border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
              <div className="h-8">{message ? message : " "}</div>
            </div>
            <div className="mt-3 sm:mt-0 sm:ml-3">
              <button
                type="submit"
                className="block w-full py-3 px-4 rounded-md bg-gradient-to-r from-indigo-500 to-indigo-600 text-white font-medium hover:from-indigo-400 hover:to-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-400 focus:ring-offset-white">
                Join
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
